// Хелперы для работы с датами — всегда локальное время, без UTC-сдвигов

export const toLocalDateString = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const todayLocal = (): string => toLocalDateString(new Date());

export const parseLocalDate = (dateString: string): Date => {
  // Принимаем 'YYYY-MM-DD' и создаём локальную дату (без UTC-сдвига)
  const parts = dateString.split('T')[0].split('-');
  if (parts.length === 3) {
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }
  return new Date(dateString);
};

export const formatLongDate = (dateString: string): string => {
  return parseLocalDate(dateString).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatShortDate = (dateString: string): string => {
  return parseLocalDate(dateString).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'short'
  });
};

export const isSameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const isToday = (dateString: string): boolean =>
  isSameDay(parseLocalDate(dateString), new Date());

export const isFuture = (date: Date): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.getTime() >= today.getTime();
};
